<template>
  <div>
    <v-tabs
      v-model="localActiveTab"
      background-color="transparent"
      color="primary"
      grow
    >
      <v-tab :ripple="false" value="feedback"> بازخورد (فیدبک) </v-tab>
      <v-tab :ripple="false" value="form"> فرم درخواست </v-tab>

      <v-tab-item class="transparent">
        <div v-if="isProductPro && value?.FeedBack?.items?.length > 0">
          <b-feedback-view
            :style="{
              background: value?.pallete?.bodyColor,
              color: value?.pallete?.textColor,
            }"
            v-model="value.FeedBack"
          />
        </div>
      </v-tab-item>

      <v-tab-item>
        <div v-if="isProductPro">
          <consultation-new-show
            :style="{
              background: value?.pallete?.bodyColor,
              color: value?.pallete?.textColor,
            }"
            :color="value?.pallete?.textColor"
            v-model="value.consultationNew"
          />
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import BFeedbackView from "@/view/pages/businessPage/components/view/bFeedbackView.vue";
import ConsultationNewShow from "@/view/components/consultationNew/consultationNewShow.vue";

export default {
  name: "DetailsTab2",

  components: {
    BFeedbackView,
    ConsultationNewShow,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    activeTab: {
      type: String,
      default: null,
    },
    opened: {
      type: Boolean,
      default: false,
    },
    palette: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      localActiveTab: "feedback",
    };
  },

  computed: {
    isProductPro() {
      return this.$route.name?.toLowerCase().includes("productpro");
    },
  },

  watch: {
    activeTab: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.localActiveTab = newVal;
        }
      },
    },

    localActiveTab(newVal) {
      this.$emit("update:activeTab", newVal);
    },

    opened: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // اگر تب خاصی از بیرون پاس داده نشده، روی feedback باز شود
          this.localActiveTab = this.activeTab || "feedback";
        }
      },
    },
  },

  mounted() {
    // اولویت: prop → fallback به feedback
    this.localActiveTab = this.activeTab || "feedback";
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-items {
  background-color: transparent !important;
}

.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}
</style>
